export default [
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        hue: '#aa00ff',
      },
      {
        saturation: -11,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        saturation: -78,
      },
      {
        hue: '#9600ff',
      },
      {
        lightness: -47,
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        hue: '#9000ff',
      },
      {
        saturation: -79,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        lightness: 30,
      },
      {
        weight: 1.3,
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        saturation: -16,
      },
      {
        hue: '#aa00ff',
      },
      {
        lightness: '0',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'all',
    stylers: [
      {
        saturation: -72,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        weight: '0.01',
      },
      {
        color: '#831f81',
      },
    ],
  },
];
